import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRentals } from '../services/api';
import { Rental } from '../types/api';

export const RentalsPage: React.FC = () => {
  const [rentals, setRentals] = useState<Rental[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    getRentals().then((response) => setRentals(response.data)).catch(() => setError('Please sign in to view rentals.'));
  }, []);

  return (
    <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-white">My rentals</h1>
      {error && <p className="mt-4 rounded-md bg-red-50 p-3 text-red-700">{error}</p>}
      <div className="mt-6 divide-y divide-stone-800 rounded-lg border border-stone-800 bg-stone-950">
        {rentals.map((rental) => (
          <div key={rental.id} className="grid gap-4 p-4 sm:grid-cols-[160px_1fr_auto]">
            <img src={rental.movie.thumbnailUrl} alt={rental.movie.title} className="aspect-video w-full rounded border border-stone-800 object-cover" />
            <div>
              <h2 className="text-xl font-semibold text-white">{rental.movie.title}</h2>
              <p className="mt-1 text-sm text-stone-300">Purchased {new Date(rental.purchaseTime).toLocaleString()}</p>
              <p className="mt-1 text-sm text-stone-300">
                {rental.expiryTime ? `Expires ${new Date(rental.expiryTime).toLocaleString()}` : '48-hour window starts on first playback'}
              </p>
            </div>
            <Link className="self-center rounded-md bg-[#ffd460] px-4 py-2 text-center font-semibold text-stone-950 hover:bg-[#ffc83d]" to={`/watch/${rental.movieId}`}>
              Play
            </Link>
          </div>
        ))}
        {!error && rentals.length === 0 && <p className="p-6 text-stone-300">No rentals yet.</p>}
      </div>
    </main>
  );
};
